import React, { Component } from 'react';
import { Input } from "@progress/kendo-react-inputs";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from 'jquery'
import { auto } from '@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core';

var idValueCount = 0;

class myInputCell extends Component {

  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });
  }

  componentDidMount = () => {

    (async () => {
      this.props.onChange({
        dataIndex: 0,
        dataItem: this.props.dataItem,
        field: this.props.field
      });

    })();

  }

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    console.log('IndispGranelQBDIndispGranelQBD')

    return (
        <td>
            {dataItem.inEdit ?
            <Input type="text"
              name={field}
              id={field}
              className='col-12'
              value={dataValue != null && dataValue != "" ? (dataValue % 1) == 0 ? dataValue.toString() : parseFloat(dataValue).toFixed(3).toString() : ''} disabled 
            />
            : dataValue != null && dataValue != "" ? (dataValue % 1) == 0 ? dataValue.toString() : parseFloat(dataValue).toFixed(3).toString() : undefined}
        </td>
    );
  }
}

export default myInputCell;